import React from 'react'
import styled from 'styled-components'

import zen from '../images/sort-az.png';
import heart from '../images/steps.png';
import speed from '../images/photo.png';

const BenefitsWrapper = styled.div`
    width:100vw;
    max-width:100%;
    height:auto;
    background: ${({ theme }) => theme.body};
    text-align:center;
    margin-bottom:4rem;
    padding-top: 3.5rem;
    display:flex;
    flex-direction:column;
    justify-items:center;
    align-items:center;
    @media (max-width: 750px){
        padding-top: 0;
    }
`

const Columns = styled.div`
    width:100vw;
    max-width:90%;
    display:grid;
    grid-template-columns: repeat(3, 1fr);
    justify-items:center;
    flex:1;
    grid-column-gap:3rem;
    
    /*mobile view */
    @media (max-width: 750px){
        grid-template-columns: repeat(1, 1fr);
    }
`
const BenefitContainer = styled.div`
    margin-top: 1rem;
    color: ${({ theme }) => theme.text};
    display:flex;
    flex-direction:column;
    h4{
        font-size: 1.2rem;
        color: ${({ theme }) => theme.text};
        margin: .5rem;
    }
    p{
        margin-top: 1rem;
        font-size: 1rem;
        color: ${({ theme }) => theme.text};
        font-weight:300;

    }
    /*mobile view */
    @media (max-width: 750px){
        padding-top: 1rem;
    }
   
`
const StyledImg = styled.img`
    width: 80px;
    align-self: center;
    @media(max-width: 750px){
        width: 80px;
    }
`

const Section = ({ data }) => {
  return (
    <React.Fragment>
      <BenefitsWrapper>
        <h2>Ce conțin cardurile de mai sus</h2>
        <Columns>
          <BenefitContainer>
            <StyledImg src={zen} />
            <p>
              Sute de fișe ordonate și sortate pe domenii și pe toate tipurile de obiective
                        </p>
          </BenefitContainer>
          <BenefitContainer>
            <StyledImg src={heart} />
            <p>
              Fiecare pas de urmat pentru succesul activității
                        </p>
          </BenefitContainer>
          <BenefitContainer>
            <StyledImg src={speed} />
            <p>
              Poze cu fiecare fișă ca să nu cotrobăi
                        </p>
          </BenefitContainer>
        </Columns>
      </BenefitsWrapper>
    </React.Fragment>
  )
}

export default Section;